/**
 * Returns true if the subject is a boolean
 * @param subject
 */
export default function isBoolean(subject) {
    return typeof subject === 'boolean';
}
